import { render, staticRenderFns } from "./Email_template.vue?vue&type=template&id=e8da6e6e&"
import script from "./Email_template.vue?vue&type=script&lang=js&"
export * from "./Email_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports